import { render } from "./PreguntasForm.vue?vue&type=template&id=6d3081ca"
import script from "./PreguntasForm.vue?vue&type=script&lang=js"
export * from "./PreguntasForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__